var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},_vm._l((_vm.answer),function(value,index){return _c('div',{key:index,staticClass:"progress-bar",class:_vm.classByValue(value),style:({ width: (100 / _vm.answer.length) + '%'}),attrs:{"role":"progressbar"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }